import(/* webpackMode: "eager" */ "/home/runner/work/sapling/sapling/packages/foundation-intranet/src/app/global-error.tsx");
